import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-5" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_17 = { class: "table-responsive" }
const _hoisted_18 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0" }
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  class: "modal fade",
  id: "create-task",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = { class: "modal-body px-4" }
const _hoisted_35 = { class: "row gy-2" }
const _hoisted_36 = { class: "col-md-4-3" }
const _hoisted_37 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "/ajouter-factureS"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
            _createTextVNode(" Ajouter facture ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "mot",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher une facture"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Service ", -1)),
              _createVNode(_component_Field, {
                modelValue: _ctx._service,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._service) = $event)),
                name: "service"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    options: _ctx.servicesOptions,
                    "preserve-search": true,
                    multiple: false,
                    searchable: true,
                    placeholder: "Sélectionner le service",
                    label: "label",
                    "track-by": "label"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "service",
                class: "text-danger"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Statut "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "statut",
                modelValue: _ctx._statut,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._statut) = $event)),
                type: "text"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    searchable: true,
                    options: [
                { value: 0, label: 'Impayé' },
                { value: 1, label: 'Annulée ' },
                { value: 2, label: 'Normalisée' },
                { value: 3, label: 'Annulée' },
                { value: 4, label: 'Normalisée_P' },
                { value: 5, label: 'Avoir' }
              ],
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner le statut" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Mois "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "mois",
                modelValue: _ctx._mois,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx._mois) = $event)),
                type: "text"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    searchable: true,
                    options: [
                { value: 0, label: 'Janvier' },
                { value: 1, label: 'Février' },
                { value: 2, label: 'Mars' },
                { value: 3, label: 'Avril' },
                { value: 4, label: 'Mai' },
                { value: 5, label: 'Juin' },
                { value: 6, label: 'Juillet' },
                { value: 6, label: 'Aout' },
                { value: 7, label: 'Septembre' },
                { value: 8, label: 'Octobre' },
                { value: 9, label: 'Novembre' },
                { value: 10, label: 'Decembre' },
              ],
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner le mois" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Année ", -1)),
              _createVNode(_component_Field, {
                name: "annee",
                modelValue: _ctx._annee,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx._annee) = $event)),
                type: "text"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    options: _ctx._annees,
                    searchable: true,
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, { placeholder: "Sélectionner une année" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "annee",
                class: "text-danger"
              })
            ])
          ])
        ])
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("table", _hoisted_18, [
          _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Montant "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Mois "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Service "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              }, "ACTIONS ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.factures, (facture, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_19, _toDisplayString(facture.date_facture), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(facture.montant_facture), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.moisNoms[parseInt(facture?.mois)]) + " " + _toDisplayString(facture?.annee), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(facture?.service?.libelle), 1),
                _createElementVNode("td", _hoisted_23, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.getStatutBadge(facture?.statut).badgeClass)
                  }, _toDisplayString(_ctx.getStatutBadge(facture.statut).text), 3)
                ]),
                _createElementVNode("td", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[16] || (_cache[16] = _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, " Actions ", -1)),
                    _createElementVNode("ul", _hoisted_26, [
                      _createElementVNode("li", null, [
                        ((facture.statut == 0 || facture.statut == 1 || facture.statut == 3))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.openNewWindow(facture)),
                              type: "button",
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Aperçu facture ")
                            ]), 8, _hoisted_27))
                          : _createCommentVNode("", true),
                        ((facture.statut == 2 || facture.statut == 4 || facture.statut == 5))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: ($event: any) => (_ctx.openNewWindow2(facture)),
                              type: "button",
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Aperçu facture ")
                            ]), 8, _hoisted_28))
                          : _createCommentVNode("", true)
                      ]),
                      (!facture.statut && facture.statut !== false)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              "data-bs-target": "#create-task",
                              "data-bs-toggle": "modal",
                              onClick: ($event: any) => (_ctx.openModal(facture.id, facture.reference)),
                              class: "dropdown-item d-flex align-items-center"
                            }, _cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Annuler ")
                            ]), 8, _hoisted_30)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h6", { class: "modal-title" }, "Voulez-vous annuler cette facture ?"),
              _createElementVNode("button", {
                type: "button",
                id: "close-modal",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_Form, {
                ref: "depensesForm",
                onSubmit: _ctx.addFactures,
                "validation-schema": _ctx.facturesSchema
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block fw-semibold mb-10" }, [
                        _createTextVNode(" Motif"),
                        _createElementVNode("span", { class: "text-danger" })
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "motifAnnuler",
                        as: "textarea",
                        placeholder: "Entrer l'observation",
                        class: "form-control shadow-none rounded-0 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "motifAnnuler",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary"
                    }, "Annuler"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      "aria-label": "Close"
                    }, " Fermer ")
                  ], -1))
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}